(() => {
  const root = document.querySelector('[data-uz-first-offer]');
  if (!root || !/^\/(products|collections)(\/|$)/.test(location.pathname)) return;
  const dismissedKey = 'uzFirstOfferDismissedAt';
  const claimedKey = 'uzFirstOfferClaimed';
  const previewMode = new URLSearchParams(location.search).get('offer_preview') === '1' && new URLSearchParams(location.search).has('preview_theme_id');
  const dismissedAt = Number(localStorage.getItem(dismissedKey) || 0);
  if (!previewMode && (localStorage.getItem(claimedKey) || Date.now() - dismissedAt < Number(root.dataset.dismissDays || 14) * 86400000)) return;
  const panel = root.querySelector('.uz-first-offer__panel');
  const form = root.querySelector('.uz-first-offer__form');
  const result = root.querySelector('[data-uz-first-offer-result]');
  const copy = root.querySelector('[data-uz-first-offer-copy]');
  const continueButton = root.querySelector('[data-uz-first-offer-continue]');
  let open = false;
  const show = () => { if (open) return; open = true; root.hidden = false; document.body.classList.add('uz-first-offer-open'); root.querySelector('.uz-first-offer__close')?.focus(); };
  const close = () => { localStorage.setItem(dismissedKey, String(Date.now())); root.hidden = true; document.body.classList.remove('uz-first-offer-open'); };
  const timer = setTimeout(show, previewMode ? 400 : Number(root.dataset.delay || 45000));
  const onExit = (event) => { if (event.clientY <= 0) show(); };
  const onScroll = () => {
    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable > 0 && (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight >= .7) show();
  };
  document.addEventListener('mouseout', onExit);
  window.addEventListener('scroll', onScroll, { passive: true });
  root.querySelectorAll('[data-uz-first-offer-close]').forEach((button) => button.addEventListener('click', close));
  continueButton?.addEventListener('click', close);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !root.hidden) close(); });
  form.addEventListener('submit', async (event) => {
    event.preventDefault(); if (!form.reportValidity()) return; form.classList.add('is-submitting');
    try { await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } }); } catch (error) { /* Still reveal the offer if a browser blocks newsletter tracking. */ }
    form.hidden = true; result.hidden = false; form.classList.remove('is-submitting'); localStorage.setItem(claimedKey, String(Date.now())); result.querySelector('a')?.focus();
  });
  copy.addEventListener('click', async () => { try { await navigator.clipboard.writeText('unique5%'); copy.textContent = 'Copied'; } catch (error) { copy.textContent = 'unique5%'; } });
  window.addEventListener('pagehide', () => { clearTimeout(timer); window.removeEventListener('scroll', onScroll); });
})();
